import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, moveVariablesOrGroupsToSet } from 'store/data/variables';

type HandlerInput = Parameters<typeof moveVariablesOrGroupsToSet>;

export function useMoveVariablesOrGroupsToSet(): Operation<(...input: HandlerInput) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }] = useActivity(ActionTypes.MOVE_VARIABLES_OR_GROUPS_TO_SET);

	function handler(...input: HandlerInput) {
		dispatch(moveVariablesOrGroupsToSet(...input));
	}

	return [{ loading, error }, handler];
}
